import type { ReactNode } from "react";

import { Row, Text } from "@/components";
import { Avatar } from "@/components/quick-access/Avatar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { dates } from "@/lib/dates";

export const CommentAuthorHeader = ({
  createdAt,
  icon,
  initials,
  name,
}: {
  createdAt: string;
  icon?: ReactNode;
  initials?: string;
  name: string;
}) => {
  /* Helpers */
  const isFromToday = dates.checkIfEqualDates(
    createdAt,
    new Date().toISOString(),
  );
  const timestamp = isFromToday
    ? dates.timeAgoForComment(createdAt)
    : dates.formatShortDate(createdAt);
  const timestampTooltip = isFromToday
    ? dates.formatShortDateTime(createdAt)
    : dates.timeAgoForComment(createdAt);

  /* Render */
  const render = () => {
    return (
      <Row className="min-w-0 items-center gap-2">
        {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
        {icon || <Avatar initials={initials || "?"} />}
        <Row className="min-w-0 items-baseline gap-1.5">
          <Text className="truncate text-sm font-medium text-slate-800">
            {name}
          </Text>
          <TooltipProvider delayDuration={300}>
            <Tooltip>
              {/* Row instead of Text because Radix asChild needs a ref-forwarding trigger. */}
              <TooltipTrigger asChild>
                <Row className="shrink-0">
                  <Text className="text-xs font-normal text-slate-500">
                    • {timestamp}
                  </Text>
                </Row>
              </TooltipTrigger>
              <TooltipContent className="rounded-md border-transparent bg-slate-800 px-2 py-1 text-xs font-medium text-slate-50 shadow-sm">
                {timestampTooltip}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </Row>
      </Row>
    );
  };

  return render();
};
